import { Box } from '@mui/material'
import { CodeBlock } from '../code-block'

type Props = {
  code: string
}

export const ListItemCodeBlock = ({ code }: Props) => {
  return (
    <Box className="MuiListItem-root" component="li" sx={{ pb: 2 }}>
      <CodeBlock
        code={code}
        variant="light"
        sx={{
          mx: 2,
          fontSize: '10px',
        }}
      />
    </Box>
  )
}
